import { useLayoutEffect, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
    const { pathname, hash } = useLocation();
    const previousPathRef = useRef("");
    const previousHashRef = useRef("");

    useEffect(() => {
        if ("scrollRestoration" in history) {
            history.scrollRestoration = "manual";
        }

        let timeoutId: ReturnType<typeof setTimeout>;
        
        const handleScroll = () => {
            clearTimeout(timeoutId);
            timeoutId = setTimeout(() => {
                const normalizedPath = pathname.replace(/^\/(id|en|my)/, "");
                sessionStorage.setItem(`scroll_${normalizedPath}`, window.scrollY.toString());
            }, 100); // Debounce untuk performa
        };

        window.addEventListener("scroll", handleScroll, { passive: true });
        
        return () => {
            clearTimeout(timeoutId);
            window.removeEventListener("scroll", handleScroll);
        };
    }, [pathname]);

    useLayoutEffect(() => {
        const normalizedPath = pathname.replace(/^\/(id|en|my)/, "");
        const previousPath = previousPathRef.current;
        const previousHash = previousHashRef.current;

        const isPathChanged = previousPath !== normalizedPath;
        const isHashRemoved = previousHash !== hash && !hash;

        if (isPathChanged || isHashRemoved) {
            // Logika restorasi scroll jika kembali dari halaman Detail ke Daftar (Shop/Farm)
            if (normalizedPath === "/shop" && previousPath.startsWith("/shop/")) {
                const savedScroll = sessionStorage.getItem(`scroll_/shop`);
                window.scrollTo({
                    top: savedScroll ? parseInt(savedScroll, 10) : 0,
                    behavior: "instant" as ScrollBehavior,
                });
            } else if (normalizedPath === "/farm" && previousPath.startsWith("/farm/")) {
                const savedScroll = sessionStorage.getItem(`scroll_/farm`);
                window.scrollTo({
                    top: savedScroll ? parseInt(savedScroll, 10) : 0,
                    behavior: "instant" as ScrollBehavior,
                });
            } else if (!hash) {
                // Halaman baru biasa, atau hash dihapus, kembali ke atas
                window.scrollTo({
                    top: 0,
                    behavior: "instant" as ScrollBehavior,
                });
            }
        }

        previousPathRef.current = normalizedPath;
        previousHashRef.current = hash;
    }, [pathname, hash]);

    return null;
}
